package com.appsyde.shared.modules.ticket.data

import kotlinx.datetime.Instant

/**
 * Parse ISO-8601 instant string; returns null on invalid format.
 * Avoids crashing on malformed server dates.
 */
internal fun parseInstantOrNull(s: String): Instant? =
    runCatching { Instant.parse(s) }.getOrNull()
